
export default function ErrorModal({ close }) {

    return (
        <>
            <h3>Error Modal</h3>
            <p>Something went wrong!</p>
            <button onClick={close}>Close</button>
        </>
    );
}
